import type { Content, ContentRelationshipField } from '@cobliteam/prismic';
import * as prismic from '@prismicio/client';

export type ChangelogDocument = Content.ChangelogsDocument;

export const changelogFetchFields = [
  'changelogs.title',
  'changelogs.name',
  'changelogs.description',
  'changelogs.resume',
  'changelogs.content',
  'changelogs.changelog',
  'changelogs.type',
  'changelogs.tag',
  'changelogs.version',
  'changelogs.link',
  'changelogs.cta_link',
  'changelogs.published_at',
  'changelogs.release_date',
  'changelogs.date',
] as const;

export type ChangelogItem = {
  id: string;
  uid: string | null;
  title: string;
  description: string;
  publishedAt: string;
  version?: string;
  badge?: string;
  link?: prismic.LinkField;
};

export function isHomeBannerItemDocument(
  item: ContentRelationshipField<'home_banner_item'> | undefined
): item is ContentRelationshipField<'home_banner_item'> & Content.HomeBannerItemDocument {
  return !!item && 'data' in item && typeof item.data === 'object';
}

export const getPrismicText = (field?: prismic.RichTextField | prismic.KeyTextField | null) => {
  if (!field) return '';
  if (typeof field === 'string') return field.trim();

  return prismic.asText(field).trim();
};

export const getPrismicDate = (...fields: Array<prismic.TimestampField | prismic.DateField | string | null | undefined>) => {
  return fields.find((field): field is string => typeof field === 'string' && field.length > 0) ?? '';
};

export const normalizeChangelog = ({ id, uid, first_publication_date, last_publication_date, data }: ChangelogDocument): ChangelogItem => {
  const link = data.link ?? data.cta_link;
  const version = getPrismicText(data.version) || undefined;

  return {
    id,
    uid,
    title: getPrismicText(data.title) || getPrismicText(data.name),
    description: getPrismicText(data.description) || getPrismicText(data.resume) || getPrismicText(data.content) || getPrismicText(data.changelog),
    publishedAt: getPrismicDate(data.published_at, data.release_date, data.date, last_publication_date, first_publication_date),
    version,
    badge: version || getPrismicText(data.type) || getPrismicText(data.tag) || undefined,
    link: prismic.isFilled.link(link) ? link : undefined,
  };
};
